<template>
  <v-container fluid>
    <v-row>
      <v-form ref="form" @submit.prevent="validateBeforeSubmit">
        <v-col cols="12">
          <v-radio-group
            v-model="vm.supportPersons"
            label="Does the person with disability impacted by the incident have support persons?"
            v-validate="'required'"
            data-vv-as="Does the person with disability impacted by the incident have support persons"
            name="supportPersons"
            :error-messages="errors.collect('supportPersons')"
          >
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-btn @click="addSubject">Add support person</v-btn>
        <template>
          <v-dialog v-model="dialog" width="600">
            <impacted-person-supports-form
              :subject="currentSubject"
              :currentIncident="currentIncident"
              v-on:subject-added="subjectAdded"
              v-on:subject-closed="subjectClosed"
            ></impacted-person-supports-form>
          </v-dialog>
        </template>
        <v-data-table
          v-if="vm.supportPersons"
          id="list-table"
          ref="datatable"
          :headers="headers"
          :items="vm.subjects"
          item-key="index"
          class="mr-2"
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td>{{ props.item.firstName}}</td>
              <td>{{ props.item.lastName}}</td>

              <td>
                <v-icon
                  slot="activator"
                  small
                  class="mr-2"
                  @click="editSubject(props.item)"
                >mdi-pencil</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
        <br />
        <v-btn color="primary" type="submit">Continue</v-btn>
      </v-form>
    </v-row>
  </v-container>
</template>


<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import impactedPersonSupports from "./impacted-person-supports-form";

Vue.use(VeeValidate);

export default {
  name: "impacted-person-supports",
  components: {
    "impacted-person-supports-form": impactedPersonSupports
  },
  data: () => ({
    vm: {},
    editedIndex: -1,
    dialog: false,
    subjectsOther: [],
    currentSubject: {},
    headers: [
      { text: "First Name", value: "firstName" },
      { text: "Last Name", value: "lastName" },
      { text: "Type", value: "subjectType" }
    ]
  }),
  props: {
    msg: String
  },
  mounted() {
    this.init();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    currentOrganisation() {
      return this.$store.getters.currentOrganisation;
    },
    currentCase() {
      return this.$store.getters.currentCase;
    },
    currentIncident() {
      return this.$store.getters.currentIncident;
    }
  },
  methods: {
    init() {
      this.vm =
        this.currentIncident == undefined ||
        this.currentIncident.impactedPersonSupports == undefined
          ? {}
          : this.currentIncident.impactedPersonSupports;
    },
    addSubject() {
      this.currentSubject = null;
      this.dialog = true;
    },
    editSubject(subject) {
      this.editedIndex = this.vm.subjects.indexOf(subject);
      this.currentSubject = subject;
      this.dialog = true;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.currentIncident.impactedPersonSupports = this.vm;
          this.$store.dispatch("setCurrentSupport", this.currentIncident);
          this.next();
          return;
        } else {
          this.$store.dispatch("setToast", {
            message: "Form errors please correct before continuing",
            color: "red darken-4"
          });
        }
      });
    },
    subjectAdded(data) {
      if (this.editedIndex > -1) {
        Object.assign(this.vm.subjects[this.editedIndex], data);
      } else {
        if (this.vm.subjects == undefined || this.vm.subjects == null) {
          this.vm.subjects = [];
        }
        this.vm.subjects.push(data);
      }
      this.currentIncident.impactedPersonSupports = this.vm;
      this.$store.dispatch("setCurrentSupport", this.currentIncident);
      this.subjectClosed();
    },
    subjectClosed() {
      this.dialog = false;
      setTimeout(() => {
        this.currentSubject = {};
        this.editedIndex = -1;
        this.$forceUpdate();
      }, 300);
    },
    next() {
      this.$emit("next-step");
    }
  },
  editItem(item) {
    this.$store.commit("setCurrentSupport", item);
    this.$router.push("/impacted-person-supports-add");
  },
  addSubject() {
    this.$store.commit("setCurrentSupport", null);
    this.$router.push("/impacted-person-supports-add");
  },
  deleteItem(item) {
    const index = this.currentCase.impactedPersonSupports.indexOf(item);
    confirm("Are you sure you want to delete this item?") &&
      this.currentCase.impactedPersonSupports.splice(index, 1);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

